import { boolean } from "yup"
import { ErrorMessages } from "logics/const"

export default function booleanRequired() {
  return boolean()
    .typeError(ErrorMessages.InvalidArgument)
    .required(ErrorMessages.Required)
}
